import React from 'react';

const Privacy = () => {
    return (
        <div className="privacy-container max-w-4xl mx-auto p-6 bg-background text-white">
            <div className="privacy-content">
                <h1 className="text-4xl font-bold mb-4">Privacy Policy</h1>

                <p className="text-text-light mb-6"><em>Last updated: July 31, 2025</em></p>

                <p className="mb-6">This Privacy Policy explains how we collect, use, and protect your personal information when you use our website. By using the site, you agree to the practices described below.</p>

                <h2 className="text-2xl font-bold mb-4 text-primary">1. Information We Collect</h2>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                    <li><strong>Account Information:</strong> When you create an account, we may collect your name, email address, and other details you provide.</li>
                    <li><strong>Usage Data:</strong> We collect information about how you interact with the site, such as pages visited and features used.</li>
                    <li><strong>Cookies:</strong> We use cookies and similar technologies to improve your experience and analyze site traffic.</li>
                </ul>

                <h2 className="text-2xl font-bold mb-4 text-primary">2. How We Use Your Information</h2>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                    <li>To provide, maintain, and improve the site and our services.</li>
                    <li>To communicate with you, respond to inquiries, and send important notices.</li>
                    <li>To personalize your experience and analyze site performance.</li>
                    <li>To comply with legal obligations and enforce our policies.</li>
                </ul>

                <h2 className="text-2xl font-bold mb-4 text-primary">3. Legal Bases for Processing (GDPR)</h2>
                <p className="mb-4">We process your personal data under the following legal bases:</p>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                    <li><strong>Consent:</strong> When you explicitly consent, such as signing up for an account or newsletter.</li>
                    <li><strong>Contract:</strong> When processing is necessary to provide the services you request.</li>
                    <li><strong>Legal Obligation:</strong> When required by law or to comply with regulations.</li>
                    <li><strong>Legitimate Interests:</strong> For security, analytics, and improving our services, unless your rights override these interests.</li>
                </ul>

                <h2 className="text-2xl font-bold mb-4 text-primary">4. Sharing Your Information</h2>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                    <li>We may share information with trusted service providers who help us operate the site, subject to confidentiality obligations.</li>
                    <li>We may disclose information if required by law or to protect our rights and safety.</li>
                    <li>We do not sell your personal data.</li>
                </ul>

                <h2 className="text-2xl font-bold mb-4 text-primary">5. Data Retention</h2>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                    <li>We retain personal data only as long as necessary for the purposes described or as required by law.</li>
                </ul>

                <h2 className="text-2xl font-bold mb-4 text-primary">6. Your Rights</h2>
                <p className="mb-4">Depending on your location, you may have rights under GDPR, CCPA, or other laws, including:</p>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                    <li>The right to access and obtain a copy of your data.</li>
                    <li>The right to request correction or deletion of your data.</li>
                    <li>The right to object to or restrict processing of your data.</li>
                    <li>The right to withdraw consent at any time.</li>
                    <li>The right to data portability.</li>
                </ul>
                <p className="mb-6">To exercise these rights, contact us as described below.</p>

                <h2 className="text-2xl font-bold mb-4 text-primary">7. Data Security</h2>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                    <li>We implement reasonable measures to protect your data from unauthorized access, alteration, or disclosure.</li>
                    <li>However, no method of transmission over the Internet or electronic storage is completely secure, so we cannot guarantee absolute security.</li>
                </ul>

                <h2 className="text-2xl font-bold mb-4 text-primary">8. International Data Transfers</h2>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                    <li>Your information may be processed in countries other than where you reside. We take steps to ensure appropriate protections are in place when data is transferred across borders.</li>
                </ul>

                <h2 className="text-2xl font-bold mb-4 text-primary">9. Children's Privacy</h2>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                    <li>Our site is not intended for children under 13. We do not knowingly collect personal data from children.</li>
                </ul>

                <h2 className="text-2xl font-bold mb-4 text-primary">10. Changes to This Policy</h2>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                    <li>We may update this Privacy Policy from time to time. We will post any changes on this page, and the updated policy will take effect once posted.</li>
                </ul>

                <h2 className="text-2xl font-bold mb-4 text-primary">11. Contact Us</h2>
                <p className="mb-6">If you have questions or requests regarding this Privacy Policy or your personal data, please contact us using the information on our site.</p>
            </div>
        </div>
    );
};

export default Privacy;